import React from 'react';

import {TFunction} from 'i18next';

import {DateRange} from 'components/ui-kit/DateRange';
import {Input} from 'components/ui-kit/Input';
import {Select} from 'components/ui-kit/Select';
import {GridFieldConfig} from 'types';

import {AuditPeriodFilter} from './PeriodFilter';

export const auditColumns = (
    t: TFunction,
    eventOptions: Array<{value: string; label: string}>,
    extendedFilters = false,
): GridFieldConfig[] => [
    {
        id: 'eventId',
        header: t('pages.recallAudit.columns.eventId'),
        width: 240,
        filter: extendedFilters ? <Input /> : undefined,
    },
    {
        id: 'eventType',
        header: t('pages.recallAudit.columns.eventType'),
        width: 240,
        filter: <Select isClearable options={eventOptions} />,
    },
    {
        id: 'organizationName',
        header: t('pages.recallAudit.columns.organization'),
        width: 190,
        filter: <Input />,
    },
    {
        id: 'organizationTin',
        header: t('pages.recallAudit.columns.tin'),
        width: 150,
        filter: <Input />,
    },
    {
        id: 'eventTimestamp',
        isSortable: extendedFilters,
        header: t('pages.recallAudit.columns.dateTime'),
        width: 180,
        filter: extendedFilters ? <AuditPeriodFilter /> : <DateRange />,
    },
    {
        id: 'userFullName',
        header: t('pages.recallAudit.columns.userName'),
        width: 180,
        filter: <Input />,
    },
    {
        id: 'userRole',
        header: t('pages.recallAudit.columns.userRole'),
        width: 170,
        filter: extendedFilters ? <Input /> : undefined,
    },
];
